import React from "react";
import Route from "../../components/Router/Route";
const defaultContext = {
    state: {
        path: window.location.pathname,
        pathVariables: {},
    },
    setState: () => { },
};
function isSamePath(config, path) {
    //path matches exact
    if (config === path)
        return [true, {}];
    //prepare for parts comparsion
    const configElements = config.split("/");
    const pathElements = path.split("/");
    //paths are not equaly long
    if (configElements.length !== pathElements.length)
        return [false, {}];
    const variables = {};
    let passedElements = 0;
    //parse variables and check if  other elements are equal
    configElements.forEach((conf, index) => {
        if (conf.startsWith("$")) {
            variables[conf.substring(1)] = pathElements[index];
            passedElements++;
        }
        else if (conf === pathElements[index])
            passedElements++;
    });
    return [passedElements === configElements.length, variables];
}
function isRoute(page) {
    return React.isValidElement(page) && page.type === Route;
}
export const RouterFactory = {
    changeLocation: (context) => {
        const { state, setState } = context;
        return (to) => {
            window.history.pushState({}, "", to);
            setState({ ...state, path: to });
        };
    },
    isCurrentPage: (router) => {
        const path = router.path;
        return (page) => {
            if (!isRoute(page))
                throw Error("<Routes> only accepts <Route> comoponent as children!");
            return isSamePath(page.props.path, path);
        };
    },
};
const RouterContext = React.createContext(defaultContext);
export default RouterContext;
